import { NavLink } from "react-router-dom";
import { useWalletBalance, usePartnerRepStatus } from "../hooks/useApi";
import { formatTomanInt } from "../utils/format";

const repItem = {
  to: "/partners/dashboard",
  label: "داشبورد همکاران",
  icon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="m11 17 2 2a1 1 0 1 0 3-3" />
      <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" />
      <path d="m21 3 1 11h-2" />
      <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" />
      <path d="M3 4h8" />
    </svg>
  ),
};

const navItems = [
  {
    to: "/dashboard",
    label: "داشبورد",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="9" rx="1" />
        <rect x="14" y="3" width="7" height="5" rx="1" />
        <rect x="14" y="12" width="7" height="9" rx="1" />
        <rect x="3" y="16" width="7" height="5" rx="1" />
      </svg>
    ),
  },
  {
    to: "/profile",
    label: "پروفایل",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="4" />
        <path d="M4 21v-1a8 8 0 0116 0v1" />
      </svg>
    ),
  },
  {
    to: "/api-keys",
    label: "کلیدهای API",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.778 7.778 5.5 5.5 0 017.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
      </svg>
    ),
  },
  {
    to: "/wallet",
    label: "کیف پول",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M19 7V4a1 1 0 00-1-1H5a2 2 0 000 4h15a1 1 0 011 1v4" />
        <path d="M3 19V5a2 2 0 012-2h14a1 1 0 011 1v2" />
        <rect x="3" y="11" width="18" height="10" rx="2" />
        <circle cx="17" cy="16" r="1" fill="currentColor" />
      </svg>
    ),
  },
  {
    to: "/subscription",
    label: "اشتراک",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 3h12l4 6-10 13L2 9z" />
        <path d="M11 3L8 9l4 13 4-13-3-6" />
        <path d="M2 9h20" />
      </svg>
    ),
  },
  {
    to: "/usage",
    label: "مصرف API",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
      </svg>
    ),
  },
  {
    to: "/models",
    label: "مدل‌ها",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2a10 10 0 1010 10" />
        <path d="M12 12l3-3" />
        <circle cx="12" cy="12" r="2" />
        <path d="M21 2l-4 4" />
        <path d="M21 2h-4" />
        <path d="M21 6V2" />
      </svg>
    ),
  },
  {
    to: "/logs",
    label: "لاگ‌ها",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    ),
  },
  {
    to: "/support",
    label: "پشتیبانی",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 14v-3a9 9 0 0118 0v3" />
        <path d="M21 14h-3a2 2 0 00-2 2v3a2 2 0 002 2h1a2 2 0 002-2v-5z" />
        <path d="M3 14h3a2 2 0 012 2v3a2 2 0 01-2 2H5a2 2 0 01-2-2v-5z" />
      </svg>
    ),
  },
];

const docsItem = {
  to: "/docs",
  label: "مستندات API",
  icon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19.5A2.5 2.5 0 016.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
    </svg>
  ),
};

export default function Sidebar() {
  const { data: wallet } = useWalletBalance();
  const { data: repStatus } = usePartnerRepStatus();
  const isRep = Boolean(repStatus?.is_representative);
  const visibleNavItems = isRep ? [...navItems, repItem] : navItems;

  return (
    <aside className="w-[260px] bg-surface border-l border-line flex flex-col shrink-0">
      {/* Logo */}
      <div className="px-6 py-5 border-b border-line">
        <div className="flex items-center gap-3">
          <img src="/logo-reverse-filled.svg" alt="ASHA-AI" className="w-8 h-8" />
          <div>
            <h1 className="text-[15px] font-semibold text-text-main leading-tight">ASHA-AI</h1>
            <p className="text-[11px] text-text-tertiary">درگاه جامع هوش مصنوعی آشا</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
        {visibleNavItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-body transition-all ${
                isActive
                  ? "bg-primary-light text-primary font-medium"
                  : "text-text-secondary hover:bg-surface-hover hover:text-text-main"
              }`
            }
          >
            {item.icon}
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* API Docs */}
      <div className="px-3 pb-3">
        <NavLink
          to={docsItem.to}
          className={({ isActive }) =>
            `flex items-center gap-3 px-3 py-2.5 rounded-lg text-body transition-all ${
              isActive
                ? "bg-primary-light text-primary font-medium"
                : "text-text-secondary hover:bg-surface-hover hover:text-text-main"
            }`
          }
        >
          {docsItem.icon}
          <span>{docsItem.label}</span>
        </NavLink>
      </div>

      {/* Wallet Mini */}
      <div className="px-4 py-3 mx-3 mb-3 rounded-lg bg-surface-muted border border-line">
        <p className="text-small text-text-tertiary mb-0.5">موجودی کیف پول</p>
        <p className="text-[15px] font-semibold text-primary font-number">
          {formatTomanInt(wallet?.balance)} <span className="text-small text-text-tertiary font-normal">تومان</span>
        </p>
      </div>
    </aside>
  );
}